//@flow

import styled from "styled-components"

export const Metrics = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`

export const Metric = styled.div`
  padding: 0 1rem;
  margin-bottom: 1rem;
  border-radius: 1rem;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-grow: 1;

  &:last-child {
    margin-bottom: 0;
  }
`

export const GraphContainer = styled.div`
  margin: 1rem 1rem 1rem 2rem;
  height: 120px;
  flex-grow: 1;
`



// WEBPACK FOOTER //
// ./src/Kiosk/Shared/AQIChart.js